module.exports = __webpack_public_path__ + "assets/img/third.864be79b.png";